module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "content-icons-ui": "static-1.2460"
    },
    "depPathPrefixes": {
      "content-icons-ui": "/content-icons-ui/static-1.2460"
    },
    "bundlingPackage": "deal-plans-ui",
    "bundlingPackageVersion": "static-1.2444",
    "project": "content-icons-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};